import { render } from "./ChannelWrapper.vue?vue&type=template&id=2a809bda&ts=true"
import script from "./ChannelWrapper.vue?vue&type=script&lang=ts"
export * from "./ChannelWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ChannelWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a809bda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a809bda', __exports__)) {
    api.reload('2a809bda', __exports__)
  }
  
  module.hot.accept("./ChannelWrapper.vue?vue&type=template&id=2a809bda&ts=true", () => {
    api.rerender('2a809bda', render)
  })

}


export default __exports__